<template>
    <div class="container-fluid">
        <h1>{{ title }}</h1>
        <br />
        <b-form
            ref="themeGroupForm"
            name="themeGroupForm"
            v-if="!isLoading"
            v-on:submit.prevent="$_onSubmit"
            class="pb-5"
        >
            <div class="col-md-6">
                <div class="form-group">
                    <!--Name-->
                    <x-input
                        id="themeGroupName"
                        type="text"
                        :text="this.$t('themeGroups.nameTitle')"
                        required
                        v-model="themeGroup.name"
                        @input="$_onInputName"
                        :invalidMessage="nameMessage"
                        :state="!errorInUse"
                        :maxlength="50"
                        :autofocus="true"
                        :disabled="isThemeGroupOverig"
                    >
                    </x-input>
                </div>
                <div v-if="themeGroup.id != -1 && !loadingThemes" class="mb-1"><span>{{ labelThemesLinked }}</span></div>
                <v-draggable
                    v-if="themeGroup.organizationThemeGroupThemes !== null"
                    :list="themeGroup.organizationThemeGroupThemes"
                    handle=".fa-arrows-alt"
                >
                    <div
                        role="tablist"
                        v-for="(theme, index) in themeGroup.organizationThemeGroupThemes"
                        :key="index"
                    >
                        <b-card no-body class="mb-1">
                            <b-card-header
                                :id="`headerTheme${theme.themeId}`"
                                v-b-toggle="`accordion${theme.themeId}`"
                                header-tag="header"
                                class="p-1"
                                role="tab"
                                data-toggle="collapse"
                            >
                                <em class="fa fa-arrows-alt"></em>
                                <span>{{ theme.themeName }}</span>
                                <span class="float-right">
                                    <!-- Delete icon in header -->
                                    <a
                                        :id="`${theme.themeId}removeTheme`"
                                        :title="$t('themeGroups.linkedThemeToDelete')"
                                        class="pr-4"
                                        @click.stop.prevent="
                                            $_removeLinkedTheme(index)
                                        "
                                    >
                                        <em class="fas fa-trash-alt fa-sm" :class="isThemeGroupOverig ? 'd-none' : ''"></em>
                                    </a>
                                </span>
                            </b-card-header>
                        </b-card>
                    </div>
                </v-draggable>
                <b-link
                        v-if="themeGroup.id != -1"
                        :id="`addtheme`"
                        :name="`addtheme`"
                        v-show="!addThemeMode && !isThemeGroupOverig"
                        @click="$_loadThemes"
                    >
                <em class="fa fa-plus"></em>&nbsp;{{
                    $t('themeGroups.themeAddTitle')
                }}
                </b-link>
                <b-card no-body v-if="addThemeMode" class="mb-3 themaSelect">
                    <b-card-body>
                        <div>
                            <b-form-group
                                :label="$t('themeGroups.labelTheme')"
                                label-for="tags-with-dropdown"
                            >
                                <b-form-tags
                                    id="tags-with-dropdown"
                                    v-model="newThemes"
                                    no-outer-focus
                                    class="mb-2"
                                >
                                    <template
                                        v-slot="{
                                            tags,
                                            disabled,
                                            addTag,
                                            removeTag
                                        }"
                                    >
                                        <ul
                                            v-if="tags.length > 0"
                                            class="list-inline d-inline-block mb-2"
                                        >
                                            <li
                                                v-for="tag in tags"
                                                :key="tag"
                                                class="list-inline-item"
                                            >
                                                <b-form-tag
                                                    @remove="removeTag(tag)"
                                                    :title="tag"
                                                    :disabled="disabled"
                                                    variant="info"
                                                    >{{ tag }}</b-form-tag
                                                >
                                            </li>
                                        </ul>
                                        <b-dropdown
                                            size="sm"
                                            variant="outline-secondary"
                                            block
                                            menu-class="limited-heigt w-100 pt-0"
                                            @shown="$_setFocusSearchTheme"
                                        >
                                            <template #button-content>
                                                {{ $t('themeGroups.labelChooseTheme') }}
                                            </template>
                                            <b-dropdown-form
                                                @submit.stop.prevent="() => {}"
                                                class="fixed"
                                            >
                                                <b-form-group
                                                    :label="$t('btnSearchLabel')"
                                                    label-for="tag-search-input"
                                                    label-cols-md="auto"
                                                    class="mb-0"
                                                    label-size="sm"
                                                    :description="searchDesc"
                                                    :disabled="disabled"
                                                >
                                                    <b-form-input
                                                        v-model="searchVal"
                                                        id="tag-search-input"
                                                        type="search"
                                                        size="sm"
                                                        autocomplete="off"
                                                        ref="searchTheme"
                                                    ></b-form-input>
                                                </b-form-group>
                                            </b-dropdown-form>
                                            <b-dropdown-item-button
                                                v-for="option in availableThemes"
                                                :key="option"
                                                @click="
                                                    $_onOptionClick({
                                                        option,
                                                        addTag
                                                    })
                                                "
                                            >
                                            {{ option }}
                                            </b-dropdown-item-button>
                                        </b-dropdown>
                                    </template>
                                </b-form-tags>
                            </b-form-group>
                        </div>
                        <!-- Theme add / cancel buttons -->
                        <div class="btn-group">
                            <b-button
                                :id="`addTheme`"
                                @click="$_addTheme"
                                variant="primary"
                                :disabled="newThemes.length === 0"
                            >
                                <span class="fa fa-check" /> {{ $t('btnAddLabel') }}
                            </b-button>
                            <b-button
                                :id="`cancelAddTheme`"
                                @click="$_cancelAddTheme"
                            >
                                <span class="fa fa-times" />
                                {{ $t('btnCancelLabel') }}
                            </b-button>
                        </div>
                    </b-card-body>
                </b-card>

                <!-- Save/cancel/remove buttons -->
                <SubmitCancelRemove
                    :is-saving="isSaving"
                    :is-deleting="isDeleting"
                    :mode="mode"
                    :isBtnSaveDisabled="isBtnSaveDisabled"
                    :isBtnRemoveDisabled="isThemeGroupOverig"
                    @cancel="$_onCancel"
                    @remove="$_onRemove"
                >
                </SubmitCancelRemove>
            </div>
        </b-form>
    </div>
</template>

<script>
    /* Store imports */
    import { mapState } from 'vuex';
    import { MODE_EDIT, MODE_ADD, THEMAGROUP_OVERIG } from '../../constants';
    import XInput from '../../components/BaseComponents/x-input.vue';
    import SubmitCancelRemove from '../../components/SubmitCancelRemove.vue';
    import modalMixin from '../../components/Mixins/ModalMixin.vue';
    import {
        numberSortFunction,
        arraySortAscendingFunction,
        arrayNotEmpty,
        convertToValueTextPair,
        nprogress
    } from '../../services/utilities/utilities';
    import draggable from 'vuedraggable';
    import { orderBy } from 'lodash';

    export default {
        name: 'ThemeGroupDetail',
        mixins: [modalMixin],

        components: {
            SubmitCancelRemove,
            'v-draggable': draggable,
            'x-input': XInput
        },

        props: { id: { type: Number, default: -1 } },

        data: function () {
            return {
                mode: 0,
                title: '',
                themeGroup: null,
                themeGroups: null,
                themes: [],
                newThemes: [],
                searchVal: '',
                // validation
                errorInUse: false,
                nameMessage: '',
                addThemeMode: false,
                loadingThemes: false,
                isLoading: true,
                isSaving: false,
                isDeleting: false
            };
        },

        computed: {
            ...mapState(['userInfo']),
            /**
             * Check if themeGroup can be saved
             * @returns {boolean} indicating if themeGroup can be saved
             */
            isBtnSaveDisabled: function () {
                return this.isSaving || this.isDeleting || this.errorInUse;
            },
            isThemeGroupOverig: function() {
                return this.themeGroup.name === THEMAGROUP_OVERIG.NAME;
            },
            labelThemesLinked() {
                return this.themeGroup.organizationThemeGroupThemes?.length > 0 ? this.$t('themeGroups.labelThemesLinked') : this.$t('themeGroups.labelNoThemesLinked');
            },
            searchDesc() {
                if (this.criteria && this.availableThemes.length === 0) {
                    return this.$t('errorSearchCriteriaNoMatch');
                }
                return '';
            },
            availableThemes() {
                const criteria = this.criteria;
                // Filter out already selected options
                const options = this.selectableThemes.filter(
                    (opt) => this.newThemes.indexOf(opt) === -1
                );
                if (criteria) {
                    // Show only options that match criteria
                    return options.filter(
                        (opt) => opt.toLowerCase().indexOf(criteria) > -1
                    );
                }
                // Show all options available
                return options;
            },
            criteria() {
                // Compute the search criteria
                return this.searchVal.trim().toLowerCase();
            },
            selectableThemes: function () {
                let options;
                if (this.themeGroup.organizationThemeGroupThemes &&
                    this.themeGroup.organizationThemeGroupThemes.length > 0) {
                    options = this.$_themeOptions().filter(
                        (opt) =>
                            this.themeGroup.organizationThemeGroupThemes.findIndex(
                                (t) => t.themeName === opt.text
                            ) === -1
                    );
                } else {
                    options = this.$_themeOptions();
                }
                return options.map((option) => {
                    return option.text;
                });
            }
        },

        created() {
            if (this.id > 0) {
                this.mode = MODE_EDIT;
                this.title = this.$t('themeGroups.detailEditTitle');
                this.$_getThemeGroup();
            } else {
                this.mode = MODE_ADD;
                this.title = this.$t('themeGroups.detailAddTitle');
                this.$_createEmptyThemeGroup();
            }
            this.$_getThemeGroups();
        },

        methods: {
            async $_getThemeGroup() {
                this.isLoading = true;
                try {
                    const themeGroupResult = await this.$store.dispatch(
                        'useApiData',
                        {
                            name: 'GetThemeGroup',
                            parameters: { Id: this.id }
                        }
                    );
                    this.themeGroup = Object.assign({}, themeGroupResult.data);
                    if (this.id === THEMAGROUP_OVERIG.NR) {
                        this.themeGroup.name = THEMAGROUP_OVERIG.NAME;
                        this.themeGroup.order = THEMAGROUP_OVERIG.NR;
                    }
                } catch (error) {
                    const data = {
                        message: error.message,
                        variant: 'danger',
                        title: this.$t('themeGroups.errorGetThemeGroup'),
                        autoHideDelay: 5000
                    };
                    this.showToast(data);
                } finally {
                    this.isLoading = false;
                }

            },
            $_createEmptyThemeGroup() {
                this.themeGroup = {
                    id: -1,
                    name: '',
                    order: undefined,
                    organizationId: this.userInfo.organizationId,
                    organizationThemeGroupThemes: null
                };
                this.isLoading = false;
            },
            /**
             * get the themeGroups
             * @returns {Array}: is used to check if new/edited themegroup name already exists
             */
            async $_getThemeGroups() {
                const themeGroupsResult = await this.$store.dispatch('useApiData', {
                    name: 'GetThemeGroups',
                    parameters: {},
                    useLoader: true
                });
                this.themeGroups = [...themeGroupsResult.data].sort(numberSortFunction('order'));
                // overig toevoegen
                let organizationId = this.userInfo.organizationId;
                this.themeGroups.push({
                    id: THEMAGROUP_OVERIG.NR,
                    name: THEMAGROUP_OVERIG.NAME,
                    order: THEMAGROUP_OVERIG.NR,
                    organizationId,
                    organizationThemeGroupThemes: null
                });
            },

            /**
             * check themeGroup existence
             */
            $_onInputName(newValue) {
                const groupFound = this.themeGroups.find((item) => {
                    return (
                        item.id !== this.id &&
                        item.name.toLowerCase() === newValue.toLowerCase()
                    );
                });

                this.errorInUse = groupFound !== undefined;
                if (this.errorInUse) {
                    this.nameMessage = this.$t('themeGroups.nameIsInUse');
                }
            },

            $_goToOverview() {
                this.$router.push({ path: '/dashboard/themeGroups' });
            },

            $_onCancel: function () {
                this.$_goToOverview();
            },

            /*
             * Removes the themeGroup
             */
            async $_onRemove() {
                const confirm = await this.msgBoxConfirm({
                    message: this.$t('themeGroups.deleteConfirmation')
                });
                if (confirm) {
                    try {
                        this.isDeleting = true;
                        await this.$store.dispatch('useApiData', {
                            name: 'DeleteThemeGroup',
                            parameters: { Id: this.themeGroup.id }
                        });
                        const data = {
                            message: this.$t('themeGroups.removed'),
                            variant: 'success',
                            autoHideDelay: 5000
                        };
                        this.showToast(data);
                        this.$_goToOverview();
                    } catch (error) {
                        const data = {
                            message: this.$t(error.message),
                            variant: 'danger',
                            title: this.$t(error.title),
                            autoHideDelay: 5000
                        };
                        this.showToast(data);
                        this.isDeleting = false;
                    } finally {
                        this.isDeleting = false;
                    }
                }
            },

            $_removeLinkedTheme(index) {
                if (index < this.themeGroup.organizationThemeGroupThemes.length) {
                    this.themeGroup.organizationThemeGroupThemes.splice(index, 1);
                }
            },

            async $_onSave() {
                this.isSaving = true;
                const body = this.themeGroup;
                const name = body.id > -1 ? 'UpdateThemeGroup' : 'CreateThemeGroup';
                const parameters = body.id > -1 ? { Id: body.id } : {};
                try {
                    const themeGroupResult = await this.$store.dispatch('useApiData', {
                        name,
                        useLoader: true,
                        parameters,
                        data: body
                    });
                    // by name themegroup added, go fill themeGroup struct, was empty
                    if (this.mode === MODE_ADD) {
                        this.themeGroup = Object.assign({}, themeGroupResult.data);
                        if (this.themeGroup.id !== -1) {
                            this.mode = MODE_EDIT;
                        }
                    }
                    const data = {
                        message: this.$t('themeGroups.saved'),
                        variant: 'success',
                        autoHideDelay: 5000
                    };
                    this.showToast(data);
                } catch (error) {
                    const messageData = {
                        message: this.$t(error.message),
                        variant: 'danger',
                        title: this.$t(error.title),
                        autoHideDelay: 5000
                    };
                    this.showToast(messageData);
                    this.isSaving = false;
                } finally {
                    this.isSaving = false;
                }
            },

            $_onSubmit() {
                if (this.$refs.themeGroupForm.checkValidity()) {
                    this.$_onSave();
                }
            },
            async $_loadThemes() {
                try {
                    this.loadingThemes = true;
                    nprogress.start();
                    if (this.themes.length === 0) {
                        const result = await this.$store.dispatch('useApiData', {
                            name: 'GetThemeOverview'
                        });
                        let themes = Object.assign([], result?.data);
                        // fill array with all themes titles
                        // only the themes without a themegroup
                        // and the themes already selected to add
                        themes.forEach((record) => {
                            if (!record.themeGroup) {
                                this.themes.push({
                                    themeName: record.name,
                                    themeId: record.id,
                                    order: 0
                                });
                            }
                        });
                        this.themes?.sort(
                            arraySortAscendingFunction('themeName', false)
                        );
                    }
                    nprogress.done();
                } catch (error) {
                    nprogress.done();
                    const data = {
                        message: error.message,
                        variant: 'danger',
                        autoHideDelay: 10000
                    };
                    this.showToast(data);
                }
                this.loadingThemes = false;
                // for ThemeGroup show all "free" themes
                if (!this.isThemeGroupOverig) {
                    // Option to add themes to themeGroup
                    this.addThemeMode = true;
                }
            },
            $_addTheme() {
                // Don't add Theme when no valid option is selected
                if (this.newThemes.length === 0) {
                    return;
                }
                for (const themeName of this.newThemes) {
                    const themeId = this.themes.find(
                            (item) => item.themeName === themeName
                    ).themeId;

                    // Continue to add themeTheme
                    let newTheme = {
                        themeName,
                        themeId,
                        order: 0
                    };
                    // if empty initialize the array now
                    if (this.themeGroup.organizationThemeGroupThemes === null) {
                        this.themeGroup.organizationThemeGroupThemes = [];
                    }
                    this.themeGroup.organizationThemeGroupThemes.push(newTheme);
                }
                this.addThemeMode = false;
                this.newThemes = [];
            },
            $_cancelAddTheme() {
                this.addThemeMode = false;
            },
            $_setFocusSearchTheme() {
                const inputField = this.$refs.searchTheme;
                if (inputField) {
                    inputField.$refs.input.focus();
                }
            },
            $_onOptionClick({ option, addTag }) {
                addTag(option);
                this.searchVal = '';
            },
            $_themeOptions() {
                if (arrayNotEmpty(this.themes)) {
                    // Select all themelayers including baselayers
                    let themeLayers = this.themes;
                    // Order by title
                    themeLayers = orderBy(themeLayers, [
                        (themeLayer) => themeLayer.themeName.toLowerCase()
                    ]);
                    // Make sorted themelayers available for other methods
                    this.themelayerOptions = themeLayers;
                    // Convert to value: id, text: title for b-form-select
                    themeLayers = convertToValueTextPair(
                        themeLayers,
                        'themeId',
                        'themeName'
                    );
                    return themeLayers;
                }
                // Solving Sonarqube code smell
                return [];
            }
        }
    };
</script>

<style scoped>
.error {
    color: red;
}

.card-header .fa {
    transition: 0.3s transform ease-in-out;
}

.card-header .collapsed .fa {
    transform: rotate(90deg);
}

.fa-arrows-alt:hover {
    cursor: move;
}

.themaSelect {
    padding-bottom: 20px;
}
</style>

